import { IAccount, LocationService, ILocation, SalaryScaleGroupService, ISalaryScaleGroup } from "../../../services/index";
import * as _ from "lodash";
interface IResolve {
    account: IAccount;
    locations: ILocation[];
}

class LocationsItemController {

    private resolve: IResolve;
    private account: IAccount;
    private location: ILocation;
    private close: any;
    private salaryScaleGroups: ISalaryScaleGroup[];

    constructor(
        private LocationService: LocationService,
        private $state: ng.ui.IStateService,
        private $stateParams: ng.ui.IStateParamsService,
        private SweetAlert: any,
        private SalaryScaleGroupService: SalaryScaleGroupService,
        private $timeout: ng.ITimeoutService
    ) {
        'ngInject';
    }


    public $onInit = () => {
        this.account = this.resolve.account;
        var locationId : string = this.$stateParams['locationId'];
        if (locationId != '') {
            this.location = _.find(this.resolve.locations, { 'id': locationId });
        } else {
            this.location = new ILocation();
        }
        
        this.salaryScaleGroups = [];
        this.SalaryScaleGroupService.all().then((result: ISalaryScaleGroup[]) => {
            this.salaryScaleGroups = result || [];
            
            // Als location een salaryScaleGroup object heeft, maar het is niet hetzelfde referentie object
            // Zoek het juiste object op basis van ID en gebruik die referentie (belangrijk voor ng-options)
            if (this.location && this.location.salaryScaleGroup && this.location.salaryScaleGroup.id) {
                const foundGroup = this.salaryScaleGroups.find(g => g.id === this.location.salaryScaleGroup.id);
                if (foundGroup) {
                    // Gebruik het object uit de array zodat de referentie overeenkomt met ng-options
                    this.location.salaryScaleGroup = foundGroup;
                }
            } else if (this.location && this.location.salaryScaleGroupId && !this.location.salaryScaleGroup) {
                // Als location alleen een salaryScaleGroupId heeft maar geen object, zoek het object op
                const foundGroup = this.salaryScaleGroups.find(g => g.id === this.location.salaryScaleGroupId);
                if (foundGroup) {
                    this.location.salaryScaleGroup = foundGroup;
                }
            }
            
            // Trigger chosen update after data is loaded
            this.$timeout(() => {
                if ((<any>window).jQuery && (<any>window).jQuery.fn.chosen) {
                    (<any>window).jQuery('.chosen').trigger('chosen:updated');
                }
            }, 200);
        }).catch((error) => {
            console.error('Error loading salary scale groups:', error);
            this.salaryScaleGroups = [];
        });
    }

    public submitLocation() {
        // Zorg dat salaryScaleGroupId wordt gezet op basis van het geselecteerde object
        if (this.location.salaryScaleGroup && this.location.salaryScaleGroup.id) {
            this.location.salaryScaleGroupId = this.location.salaryScaleGroup.id;
        } else {
            this.location.salaryScaleGroupId = null;
            this.location.salaryScaleGroup = null;
        }
        
        if (this.location.id === undefined) {
            this.location.accountId = this.account.id;
            this.LocationService.post(this.location).then((data) => {
                this.closeModal();
            });
            // this.locations.push(this.location);
        } else {
            this.LocationService.put(this.location.id, this.location).then((data) => {
                this.closeModal();
            });
        }
    }

    delete() {

        this.SweetAlert.swal({
            title: 'Let op!',
            text: 'Weet u zeker dat u '+ this.location.name +' wilt verwijderen?',
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#2ECC71',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ja',
            cancelButtonText: 'Nee, annuleren',
        }, (isConfirm) => {
            if (isConfirm) {
                this.LocationService.delete(this.location.id).then((data) => {
                    this.closeModal();
                });
            } else {

            }
        });        
      
    }

    private closeModal() {
        this.$state.go('^', {tab: 3}, {reload: true});
    }
}

export const locationsItemComponent = { 
    bindings: {
        resolve : "<",
        close: "&"
    },
    controller: LocationsItemController,
    template: require('./locations.item.html')
};



// WEBPACK FOOTER //
// ./src/app/modules/crm/locations/locations.item.component.ts